"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  getTopLevelDomain: () => getTopLevelDomain
});
module.exports = __toCommonJS(src_exports);

// src/location.ts
var topLevelDomains = [
  // Origin top level domains.
  // https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains#Original_top-level_domains.
  "com",
  "net",
  "org",
  "int",
  "mil",
  "edu",
  "gov",
  // Domains from Certifier
  // https://certifier.sc-corp.net/request/dns?select=create
  "io",
  "as",
  "co",
  "ly",
  "ht",
  "ar",
  "co.uk",
  // Domains from Google
  "app"
  // For Cloud Run's *.run.app
];
var getTopLevelDomain = /* @__PURE__ */ __name((hostname) => {
  const topLevelDomain = topLevelDomains.find((tld) => hostname.endsWith(tld));
  if (!topLevelDomain)
    return hostname;
  const noTld = hostname.substring(0, hostname.length - topLevelDomain.length - 1);
  const lastPeriod = noTld.lastIndexOf(".");
  return lastPeriod > 0 ? `${hostname.substring(lastPeriod + 1)}` : hostname;
}, "getTopLevelDomain");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getTopLevelDomain
});
//# sourceMappingURL=index.cjs.map
